import PropTypes from 'prop-types';
import uniqid from 'uniqid';

import './conceptInfo.scss';

const ConceptInfo = ({ concept }) => {
  if (!concept) {
    return null;
  }

  return (
    <div className="gw-concept-info">
      <h4 className="gw-concept-info__name">{concept.name}</h4>
      {concept?.texts?.description && (
        <div className="gw-concept-info__description">{concept.texts.description}</div>
      )}
      {concept?.usps?.items?.length && (
        <ul className="gw-concept-info__usps">
          {concept?.usps?.items?.map((usp) => (
            <li key={uniqid('gw-concept-info-usps-item-')} className="gw-concept-info__usps-item">{usp}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

ConceptInfo.propTypes = {
  concept: PropTypes.shape({
    name: PropTypes.string,
    texts: PropTypes.shape({
      description: PropTypes.string,
    }),
    usps: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
};

export default ConceptInfo;
